<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh()">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="onCreate()" v-if="this.expressFeePromotionData.length <= 0">{{generateCustomizeString('add')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="expressFeePromotionData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="promotionListLoading">
        <el-table-column prop="title" :label="generateCustomizeString('promotion')" width="150">
        </el-table-column>
        <el-table-column prop="mobile_url" :label="generateCustomizeString('promotionGoodsListUrl')" width="350">
          <template slot-scope="scope">
            <a :href="mobileUrl + '/express-fee-promotion/' + scope.row.id" target="_blank">
              <span>{{ mobileUrl + '/express-fee-promotion/' + scope.row.id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="pc_url" :label="generateCustomizeString('promotionGoodsListPCUrl')" width="400">
          <template slot-scope="scope">
            <a :href="pcUrl + '/promotion/express-fee/' + scope.row.id" target="_blank">
              <span>{{ pcUrl + '/promotion/express-fee/' + scope.row.id }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="details" :label="generateCustomizeString('promotionDetail')">
          <template slot-scope="scope">
            <span>{{ generateCustomizeString('spendMoreThan') + scope.row.threshold + generateCustomizeString('willBeFreeShipping') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onEdit(scope.row)">{{ generateCustomizeString('edit') }}</el-button>
            <el-button type="text" size="small" @click="onRemove(scope.row)">{{ generateCustomizeString('delete') }}</el-button>
            <el-dialog :title="generateCustomizeString('confirmDelete')" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{generateCustomizeString('deleteCancel')}}</el-button>
                <el-button type="primary" @click="deletePromotion()">{{generateCustomizeString('deleteConfirm')}}</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'FreeExpressFeePromotion',
  data() {
    return {
      expressFeePromotionData: [],
      promotionListLoading: false,
      dialogVisible: false,
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchPromotionData()
    },
    onCreate() {
      this.$router.push({
        name: 'CreateExpressFeePromotion'
      })
    },
    onEdit(row) {
      this.$router.push({
        name: 'EditExpressFeePromotion',
        params: {
          promotionId: row.id
        }
      })
    },
    onRemove(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    deletePromotion() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'activity/freeshipping/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchPromotionData()
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    },
    fetchPromotionData() {
      if (this.promotionListLoading) return
      this.promotionListLoading = true
      request({
        url: 'activity/freeshipping/list',
        method: 'get'
      })
        .then(response => {
          const data = response.data
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.title = response.data[i].title
            obj.shopId = response.data[i].shop_id
            obj.threshold = parseFloat(response.data[i].threshold / 100 * 1000 / 1000).toFixed(2)
            data[i] = obj
          }
          this.expressFeePromotionData = data
          console.log(this.expressFeePromotionData)
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.promotionListLoading = false
        })
    }
  },
  created() {
    if (location.host.includes('ieshop.co.nz')) {
      const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
      if (this.pcUrl.includes('nzmai.com.cn')) {
        this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
      }
    }
    this.fetchPromotionData()
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
</style>
